<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">Customers view details </h2>
    <button mat-icon-button mat-dialog-close>
       <mat-icon>close</mat-icon>
    </button>
 </div>
 <mat-dialog-content>
    <div class="row">
       <div class="col-sm-12">
          <div class="member_profile">
             <div class="bgt_colorkk"></div>
             <img [src]="parentdata.customerData.image_thumb_url" onerror="this.src='../../../../../assets/images/user-avatar.svg'" alt=""/>
               <div class="customer_heading">
                  <h3> {{parentdata.customerData.name}}</h3>
                  <p style="margin-bottom: 5px;"> {{parentdata.customerData.cust_phone}}</p>
                  <p> {{parentdata.customerData?.email && parentdata.customerData?.email != '' && parentdata.customerData?.email != 'null'  ? parentdata.customerData?.email : 'No email added'}}</p>
               </div>
               <div class="chatnow_btn_sed" *ngIf="parentdata.customerData.profile_hash_id && parentdata.customerData.profile_hash_id != 'null' &&  parentdata.customerData.profile_hash_id != '---'">
                  <button mat-flat-button (click)="openMessages(parentdata.customerData)">
                     Chat now 
                     <!-- <mat-icon>send</mat-icon> -->
                  </button>
               </div>
            </div>
          <!-- <div  style="margin-bottom: 30px;display: flex;align-items: baseline;justify-content: end;">
             <div>
                <span class="material-icons icon_mat" style="font-size: 20px;top: 5px;"> edit </span>
             </div>
             <div style="cursor: pointer;">
                Edit
             </div>
          </div> -->
       </div>
       <!-- <div class="col-md-12">
          <div class="sub_one sub_margin">
             <div class="sub_one_cont">
                <div>
                   <span class="material-icons icon_mat"> person </span>
                </div>
                <div class="entity_detail make_text_grey">
                   Name
                </div>
             </div>
             <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                   {{parentdata.customerData.name}}
                </div>
             </div>
          </div>
       </div>
       <div class="col-md-12">
          <div class="sub_one sub_margin">
             <div class="sub_one_cont">
                <div>
                   <span class="material-icons icon_mat"> call </span>
                </div>
                <div class="entity_detail make_text_grey">
                   Phone
                </div>
             </div>
             <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.customerData.cust_phone}}
                </div>
             </div>
          </div>
       </div> -->
       <!-- <div class="col-md-12">
          <div class="sub_one sub_margin">
             <div class="sub_one_cont">
                <div>
                   <span class="material-icons icon_mat"> mail </span>
                </div>
                <div class="entity_detail make_text_grey">
                   Email
                </div>
             </div>
             <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 30px; font-size: 15px;">
                  {{parentdata.customerData.name}}
                </div>
             </div>
          </div>
       </div> -->
       <div class="customer_review_section" style="    margin-top: 30px;
       border-bottom: 1px solid #ddd;
       margin-bottom: 25px;">
          <div class="sub_one sub_margin openchan">
             <div class="sub_one_cont">
                <div>
                   <span class="material-icons icon_mat"> transgender </span>
                </div>
                <div class="entity_detail make_text_grey">
                   Gender
                </div>
             </div>
             <div class="sub_one_cont main_text">
                <div class="entity_detail" style="margin-left: 34px;font-size: 15px;">
                  {{parentdata.customerData.gender1}}
                </div>
             </div>
          </div>

          <div class="sub_one sub_margin">
            <div class="sub_one_cont">
               <div>
                  <span class="material-icons icon_mat"> calendar_month </span>
               </div>
               <div class="entity_detail make_text_grey">
                  DOB
               </div>
            </div>
            <div class="sub_one_cont main_text">
               <div class="entity_detail" style="margin-left: 34px;font-size: 15px;">
                 {{parentdata.customerData.dob && parentdata.customerData.dob != '---' ? (parentdata.customerData.dob | date) : '---'}}
               </div>
            </div>
         </div>
      </div>
<!-- <hr /> -->
      <div class="customer_review_section  " style="border-bottom: 1px solid #ddd;
      margin-bottom: 25px;">
         <div class="sub_one sub_margin openchan">
            <div class="sub_one_cont">
               <div>
                  <span class="material-icons icon_mat"> work_history </span>
               </div>
               <div class="entity_detail make_text_grey">
                  Last booking
               </div>
            </div>
            <div class="sub_one_cont main_text">
               <div class="entity_detail">
                   <div class="entity_detail" style="margin-left: 34px; font-size: 15px;">
                       
                    {{parentdata.customerData.last_booking_date && parentdata.customerData.last_booking_date != '---'  ? (parentdata.customerData.last_booking_date | date) : '---'}}
                    </div>
               </div>
            </div>
         </div>
         <div class="sub_one sub_margin">
            <div class="sub_one_cont">
               <div>
                  <span class="material-icons icon_mat"> payments </span>
               </div>
               <div class="entity_detail make_text_grey">
                  payment due
               </div>
            </div>
            <div class="sub_one_cont main_text">
               <div class="entity_detail" style="margin-left: 34px; font-size: 15px;">
                 {{parentdata.customerData.currency_symbol}}{{parentdata.customerData.total_due.toFixed(2)}}
               </div>
            </div>
         </div>
      
      </div>
      <div class="customer_review_section  " >
         <div class="sub_one sub_margin openchan" style="border-right: none;width: auto;">
            <div class="sub_one_cont">
               <div>
                  <span class="material-icons icon_mat"> notes </span>
               </div>
               <div class="entity_detail make_text_grey">
                  Notes
               </div>
            </div>
            <div class="sub_one_cont main_text">
               <div class="entity_detail">
                   <div class="entity_detail" style="margin-left: 34px; font-size: 15px;">
                       
                    {{parentdata.customerData.notes && parentdata.customerData.notes != '---' && parentdata.customerData.notes != '' && parentdata.customerData.notes != 'null'  ? (parentdata.customerData.notes ) : 'No notes added'}}
                    </div>
               </div>
            </div>
         </div>
      
      </div>
       <!-- <div class="col-md-12">
          <div class="sub_one sub_margin">
             <div class="sub_one_cont">
                <div>
                   <span class="material-icons icon_mat"> list_alt </span>
                </div>
                <div class="entity_detail make_text_grey" style="margin-bottom: 8px;">
                   Short bio
                </div>
             </div>
             <div class="sub_one_cont main_text">
                <div class="sub_one_cont main_text">
                   <div class="entity_detail" style="margin-left: 34px;font-size: 15px;">
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                   </div>
                </div>
             </div>
          </div>
       </div> -->
     
    </div>
 </mat-dialog-content>